import {Component, Input, ViewChild, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {MatSort} from "@angular/material/sort";
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {FundService} from "../../../fund-service.service";
import {debounceTime, distinctUntilChanged} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import role from "../../../../interfaces/role";

@Component({
    selector: 'fund-participants',
    templateUrl: './fund-participants.component.html',
    styleUrls: ['./fund-participants.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FundParticipantsComponent {

  @ViewChild(MatSort) sort: MatSort
  @Input() participants:{[key:string]: any} = {}
  @Input() CREARoles:any[] = [];
  @Input() thirdPartyRoles:any[] = []
  @Input() permissions:any;
  @Output('save') saveForm:EventEmitter<any> = new EventEmitter<any>()
  @Output('delete') deleteForm: EventEmitter<any> = new EventEmitter<any>()
  public isExpanded = true;
  public editMode= false;
  public forms:any
  public arrs:any
  public editColumns:string[] = ['role', 'participant']
  public searchResults:any[]

  constructor(private fb: FormBuilder, private fundService: FundService) {
  }

  getDataSource(key:string){
      this.participants[key].dataSource.sort = this.sort;
      return this.participants[key].dataSource
  }


  public toggleEdit(){
    this.editMode = !this.editMode
    if(this.editMode){
      this._setEditValues()
    }
  }


  public addEditRow(detail:any){
    if(detail.value.data.length == 0){
      let newGroup = new FormGroup({
        id: new FormControl(null),
        participant: new FormControl(null),
        role: new FormControl(detail.value.role)
      })
      detail.controls.data.push(newGroup)
      detail.controls.data.push(newGroup)
    } else {
      let newGroup = new FormGroup({
        id: new FormControl(null),
        participant: new FormControl(null),
        role: new FormControl(detail.value.role)
      })
      detail.controls.data.push(newGroup)

    }
  }

  public searchParticipant(row:any, index:number, val:any, key:string){
    let roleName = row.value.role.name ?? row.value.role;

    row.controls.participant.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((value:string) => {
      if(value.length > 0){
        if(key==='ThirdPartyParticipants'){
          this.fundService.getOrganizationSearch(value, roleName, (response:any) => {
              this.searchResults = []
              for(let o = 0; o < response.data.search_organizations.data.length; o++) {
                let orgData = response.data.search_organizations.data[o]
                for(let d = 0; d < orgData.entity.entity_types.length; d++){
                  if(orgData.entity.entity_types[d]?.type?.tagType?.name == 'role' && !this.searchResults.includes(orgData)){
                    this.searchResults.push(orgData)
                  }
                }
              }
          });

        }
        if(key==='CREAParticipants'){
          this.fundService.getParticipantSearch(value, roleName, (response:any) => {
            this.searchResults = []
            let isFMRole = roleName.toLowerCase().includes('fund')
            let isSynRole = roleName.toLowerCase().includes('syndications')
            for(let p = 0; p < response.data.search_active_users.length; p++){
              let personData = response.data.search_active_users[p]
              for(let d = 0; d < personData.entity.entity_types.length; d++){
                if(isFMRole && personData.entity.entity_types[d]?.type?.name.toLowerCase().includes('fund')&& personData.entity.entity_types[d]?.type?.tagType?.name == 'role'
                && !this.searchResults.includes(personData)){
                    this.searchResults.push(personData)
                }
                if(isSynRole && personData.entity.entity_types[d]?.type?.name.toLowerCase().includes('syndications') && personData.entity.entity_types[d]?.type?.tagType?.name == 'role'
                && !this.searchResults.includes(personData)){
                  this.searchResults.push(personData)
                }
              }
            }
          })
        }
      }
    })
  }

  public displayVal(option:any): string {
    if(option === null){
      return ''
    }
    if(typeof option === "string"){
      return option;
    }
    return option.name

  }

  public updateParticipants(){
    let updatedParticipants:any[] = []
    let keys = Object.keys(this.forms);
    for(let r = 0; r < keys.length; r++){
      let keyData = this.forms[keys[r]]
      for(let d = 0; d < keyData.length; d++){
        if(keyData[d].touched){
          let roleId = keyData[d].value.role_id
          keyData[d].value.data.forEach((pr:any) => {
            let participantObj = {
              role_id: roleId,
              keyType: keys[r],
              participant_id: pr.participant.id,
              id: pr.id
            }
            updatedParticipants.push(participantObj)
          })

        }
      }
    }
    this.saveForm.emit(updatedParticipants)
    this.toggleEdit()
  }

  public deleteParticipant(event:any, row:any, index:number, key:string){
    if(event.value.id!==null){
      this.deleteForm.emit({id:event.value.id, key:key})
      if(row.controls.data.controls.length>1){
        row.controls.data.controls.splice(index,1)
      } else {
        row.controls.data.controls[index].controls.participant.setValue(null)
      }
    } else {
      if(row.controls.data.controls.length>1){
        row.controls.data.controls.splice(index,1)
      }

    }
  }



  private _setEditValues(){

    let keys = Object.keys(this.participants)

    this.forms = {}
    this.arrs = {}
    for(let i = 0; i < keys.length; i++){
      this.forms[keys[i]] = []
      if(keys[i] === 'ThirdPartyParticipants'){
        for(let t = 0; t < this.thirdPartyRoles.length; t++){
          let participants = this.participants[keys[i]].dataSource.data;
          let thirdArray:FormArray = new FormArray<any>([])
          let form = new FormGroup({
            id: new FormControl(null),
            role: new FormControl(this.thirdPartyRoles[t].name),
            participant: new FormControl(null)
          })
          participants.forEach((participant:any) => {
            if(participant.role_id === this.thirdPartyRoles[t].id){
              form.controls['id'].setValue(participant.id)
              form.controls['participant'].setValue(participant.participant)
            }
          })
          thirdArray.push(form)
          if(thirdArray.length>0){
            this.forms['ThirdPartyParticipants'].push(new FormGroup({
              role_id: new FormControl(this.thirdPartyRoles[t].id),
              role: new FormControl(this.thirdPartyRoles[t].name),
              data: thirdArray
            }))
          } else {
            this.forms['ThirdPartyParticipants'].push(new FormGroup({
              role_id: new FormControl(this.thirdPartyRoles[t].id),
              role: new FormControl(this.thirdPartyRoles[t].name),
              data: new FormArray([
                new FormGroup({
                  id: new FormControl(null),
                  role: new FormControl(this.thirdPartyRoles[t].name),
                  participant: new FormControl(null)
                })
              ])
            }))
          }
          this.forms['ThirdPartyParticipants'] = [...this.forms['ThirdPartyParticipants']].sort((a:any, b:any) => a.value.role.localeCompare(b.value.role))
        }
      }
      if(keys[i] === 'CREAParticipants'){
        for(let c = 0; c < this.CREARoles.length; c++){
          let participants = this.participants[keys[i]].dataSource.data;
          let creaArray:FormArray = new FormArray<any>([])

          participants.forEach((participant:any) => {
            if(participant.role_id === this.CREARoles[c].id){
              let form = new FormGroup({
                id: new FormControl(participant.id),
                role: new FormControl(this.CREARoles[c].name),
                participant: new FormControl(participant.participant)
              })
              creaArray.push(form)
            }
          })
          if(creaArray.length>0){
            this.forms['CREAParticipants'].push(new FormGroup({
              role_id: new FormControl(this.CREARoles[c].id),
              role: new FormControl(this.CREARoles[c].name),
              data: creaArray
            }))
          } else {
            this.forms['CREAParticipants'].push(new FormGroup({
              role_id: new FormControl(this.CREARoles[c].id),
              role: new FormControl(this.CREARoles[c].name),
              data: new FormArray<any>([
                new FormGroup({
                  id: new FormControl(null),
                  role: new FormControl(this.CREARoles[c].name),
                  participant: new FormControl(null)
                })
              ])
            }))
          }
          this.forms['CREAParticipants'] = [...this.forms['CREAParticipants']].sort((a:any, b:any) => a.value.role.localeCompare(b.value.role))
        }
      }

    }

  }

  protected readonly Object = Object;
}
